import { render } from "./MediaView.vue?vue&type=template&id=0e7a848a&scoped=true"
import script from "./MediaView.vue?vue&type=script&lang=js"
export * from "./MediaView.vue?vue&type=script&lang=js"

import "./MediaView.vue?vue&type=style&index=0&id=0e7a848a&scoped=true&lang=css"

import exportComponent from "D:\\work\\application\\chat\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e7a848a"]])

export default __exports__